import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/core/auth/useSession';
import { ROUTES } from '@/core/config/routes';
export function AuthGuard({ children }) {
    const { autenticado, hidratado } = useSession();
    const location = useLocation();
    if (!hidratado) {
        return (_jsx("div", { className: "flex min-h-screen items-center justify-center", children: _jsx("div", { className: "h-6 w-6 animate-spin rounded-full border-2 border-border border-t-primary" }) }));
    }
    if (!autenticado) {
        return _jsx(Navigate, { to: ROUTES.login, replace: true, state: { redirectTo: location.pathname } });
    }
    return _jsx(_Fragment, { children: children });
}
